/*
 * ZENZENA věrnostní program — lišta + správce dárků.
 *
 * Lišta (zenzena-upsell-bar) se re-renderuje přes nativní pipeline theme.js:
 * přidá své section ID do "cart:prepare-bundled-sections" a na "cart:change"
 * vymění HTML dodané Section Rendering API (fallback: vlastní fetch).
 *
 * Správce dárků drží invariant: dárkové položky (property _zz_gift) jsou
 * v košíku právě tehdy, když je na ně nárok, varianty jsou skladem a
 * zákaznice je neodmítla (sessionStorage).
 *
 * Tři nezávislé skupiny dárků:
 *   trio  — shaker + odměrka ke kolagenu, nárok = kolagen v košíku
 *   musli — müsli zdarma, nárok = výše košíku nad prahem
 *   akce  — AKCE 11.11: dárek za 0 Kč, nárok = akce běží (window.ZZAkce,
 *           snippets/zenzena-akce-head.liquid) a mezisoučet je nad prahem
 *           dárku (server, data-akce-nad-prahem). Viz akceGift().
 *
 * Kolik shakerů a odměrek se má přibalit počítá SERVER po jednotlivých řádcích
 * košíku (data-shaker-qty / data-odmerka-qty), protože dva kolageny můžou mít
 * každý jinou volbu příslušenství. Tady se to jen čte.
 *
 * Skupiny dárků se posílají ODDĚLENĚ: cart/add.js je atomický, takže vyprodané
 * müsli v jedné dávce s triem by shodilo i shaker s odměrkou.
 *
 * Müsli má dvě příchutě a `gifts()` vrací OBĚ, i když kvalifikuje jen zvolená.
 * Vypadá to zbytečně, ale je to nosné: odebírací větev iteruje jen přes to,
 * co `gifts()` vrátila. Kdyby se vracela jen zvolená příchuť, po přepnutí by
 * ta předchozí zůstala mimo dosah manageru, BXGY by pokryla jen jednu a druhá
 * by se zákaznici naúčtovala.
 *
 * Nárok na müsli se NEPOČÍTÁ tady, ale na serveru (data-musli-qualifies).
 * V /cart.js totiž chybí rozpad order-level slev na jednotlivé řádky, takže
 * to, co počítá Liquid, se v JS spočítat nedá.
 */

const CONFIG_SELECTOR = "[data-zz-config]";
const GIFT_PROPERTY = "_zz_gift";
const MUSLI_CHOICE_KEY = "zz_musli_choice";
// Rozpočet průchodů reconcile v klouzavém okně. Přepnutí příchuti stojí dva
// zápisy do košíku (odebrat starou, přidat novou), takže původní 4 nestačily.
// Kolik zásahů do košíku smí proběhnout v jednom okně. Složitý košík se
// srovnává po krocích a každý krok je jedna mutace: dva kolageny s různou
// volbou + překročený práh na müsli spotřebují 5 kol, než se ustálí.
// Rozpočet 6 byl proto na hraně a jedno kolo navíc ho utrhlo.
const ITERATION_BUDGET = 12;
// Jak dlouho se po spuštění zarážky do košíku nesahá, než se to zkusí znovu.
const STOP_COOLDOWN_MS = 10000;
// Okno, ve kterém se počítají zásahy do košíku. Je to OKNO OD PRVNÍHO ZÁSAHU,
// ne „ticho po posledním" — dřív se časovač při každém průchodu posouval, takže
// se čítač u aktivní zákaznice nevynuloval nikdy a jen rostl.
const ITERATION_WINDOW_MS = 5000;
const PAID_BLOCKED_KEY = "zz_paid_blocked";
// Jak dlouho platí pozorování „dárek byl v košíku". Viz hadGift().
const HAD_GIFT_TTL_MS = 60000;
// Pojistka proti překlápění: dárek, který správce sám odebral, se ke STEJNÉMU
// placenému košíku znovu nepřidá dřív než za tuhle dobu. Zarážka ITERATION_BUDGET
// pomalou smyčku nechytí - 17. 9. 2026 se müsli přidávalo a odebíralo zhruba
// jednou za 0,7 s, tedy ~8 zásahů za 5 s, pod rozpočtem 12, a jelo to donekonečna.
const FLIP_GUARD_MS = 30000;

/*
 * Dárek akce 11.11 se přidává MIMO SLEDOVÁNÍ Shopify, ať neposílá do Mety
 * falešné AddToCart. Převzato z kopie ZZ Kosik bez falesnych ATC
 * (206596964684, commit eb933a4), tam změřené 27. 9. 2026:
 *
 * Shopify (web-pixels-manager) obaluje window.fetch i XMLHttpRequest a z odpovědí
 * /cart/add.js (i /cart/update.js s novým řádkem) skládá product_added_to_cart,
 * z něj pixel F&I posílá AddToCart. /cart/change.js událost nevyrábí. Nový řádek
 * s vlastností _zz_gift bez události oficiálně vytvořit nejde, proto tentýž
 * /cart/add.js odeslaný fetchem z neviditelného rámce na stejné doméně: Shopify
 * obaluje jen fetch hlavního okna. Košík, cookies i odpověď jsou stejné.
 *
 * Když rámec nejde vytvořit, jde běžný fetch: dárek funguje, jen se vrátí
 * falešné AddToCart. Selhání je vždycky na stranu „dárek funguje".
 *
 * ZATÍM JEN PRO SKUPINU „akce". Trio a müsli jdou dál běžným fetchem: přepnutí
 * i u nich je samostatné rozhodnutí, které v kopii 206596964684 čeká na Jakuba.
 */
let zzRam = null;
function fetchMimoSledovani() {
  try {
    if (!zzRam || !zzRam.isConnected || !zzRam.contentWindow) {
      zzRam = document.createElement("iframe");
      zzRam.setAttribute("aria-hidden", "true");
      zzRam.tabIndex = -1;
      zzRam.title = "";
      zzRam.style.display = "none";
      (document.body || document.documentElement).appendChild(zzRam);
    }
    const okno = zzRam.contentWindow;
    if (okno && typeof okno.fetch === "function") return { posli: okno.fetch.bind(okno), mimo: true };
  } catch (e) {
    console.warn("[zz-loyalty] rámec pro dárek nejde vytvořit, jde běžný fetch", e);
  }
  return { posli: window.fetch.bind(window), mimo: false };
}

class ZZGiftManager {
  constructor() {
    this.busy = false;
    this.pending = false;
    this.iterations = 0;
    this.iterationResetTimer = null;
    this.stopped = false; // zarážka proti oscilaci, sama se po chvíli pustí
    this.stopResetTimer = null;
    this.staleRetryTimer = null;
    this.paidSince = {}; // variantId -> timestamp prvního pozorování nezlevněného dárku
    this.paidRecheck = null;
    // Dárky, které se nepodařilo dostat zdarma. VĚDOMĚ jen v paměti a jen
    // pro současné složení košíku — dřív se to zapisovalo do sessionStorage
    // jako „zákaznice dárek odmítla" a platilo to do konce návštěvy. Když
    // se příčina mezitím spravila (typicky nastavení slev v administraci),
    // zákaznice se k dárku už nedostala ani po přidání dalšího zboží.
    this.paidBlocked = new Set();
    this.cartSignature = null;
    this.autoRemoved = {}; // variantId -> { podpis, cas } odebrání samotným správcem
  }

  // Správce dárek sám odebral. Zapamatuje se i podpis placeného košíku:
  // jakmile zákaznice změní, co kupuje, pojistka neplatí.
  zapamatujOdebrani(variantId) {
    this.autoRemoved[variantId] = { podpis: this.cartSignature, cas: Date.now() };
  }
  nedavnoOdebrano(variantId) {
    const z = this.autoRemoved[variantId];
    if (!z) return false;
    if (z.podpis !== this.cartSignature || Date.now() - z.cas > FLIP_GUARD_MS) {
      delete this.autoRemoved[variantId];
      return false;
    }
    return true;
  }

  // Dárky, které se nepodařilo dostat zdarma.
  //
  // Tohle BYLO vědomě jen v paměti, aby blokace nepřežila do konce návštěvy.
  // Jenže stránka /cart se po KAŽDÉM zápisu do košíku celá reloaduje
  // (dispatchCartChange), takže tam vznikla nová instance správce s prázdnou
  // pamětí — a placené müsli se donekonečna přidávalo, pojistkou odebíralo
  // a stránka se každých ~5 s reloadovala. Zákaznice se nedostala k pokladně.
  //
  // Držíme to proto v sessionStorage SVÁZANÉ S PODPISEM placeného zboží:
  // reload přežije, ale jakmile zákaznice změní, co kupuje, blokace padá sama.
  // Tím zůstává zachovaný původní záměr (blokace není na celou návštěvu).
  nactiPaidBlocked(podpis) {
    try {
      const syrove = sessionStorage.getItem(PAID_BLOCKED_KEY);
      if (!syrove) return new Set();
      const data = JSON.parse(syrove);
      if (data.podpis !== podpis) return new Set();
      return new Set(data.varianty || []);
    } catch (e) { return new Set(); }
  }
  ulozPaidBlocked() {
    try {
      sessionStorage.setItem(PAID_BLOCKED_KEY, JSON.stringify({
        podpis: this.cartSignature,
        varianty: [...this.paidBlocked],
      }));
    } catch (e) { /* private mode */ }
  }
  // Konfigurace ze sekce, která OPRAVDU patří k právě načtenému košíku.
  //
  // Sekci vykresluje server, takže po každém zásahu do košíku chvíli zaostává.
  // Dokud zaostává, hlásí nárok podle STARÉHO košíku — typicky „0 dárků“ —
  // a správce dárek, který právě přidal, poslušně zase odebral. Přesně tohle
  // byla ta hlášená vada „nepřidává se automaticky, ale přes košík to jde“:
  // ruční tlačítko volá restoreAllGifts, který doběhne dřív, než konfigurace
  // stihne zestárnout.
  //
  // Když ani doptaná sekce nesedí, vrací null a reconcile RADĚJI NESÁHNE NA NIC.
  // Nesahat je vždycky lepší než sahat podle špatných čísel.
  async cerstvaKonfigurace(podpis) {
    const vDom = document.querySelector(CONFIG_SELECTOR);
    if (vDom && (vDom.dataset.paidSignature || "") === podpis) return vDom;

    const bar = document.querySelector("zenzena-upsell-bar");
    const sectionId = bar && bar.getAttribute("section-id");
    if (!sectionId) return null;
    try {
      const html = await (await fetch(`${Shopify.routes.root}?section_id=${sectionId}`)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const cerstva = doc.querySelector(CONFIG_SELECTOR);
      if (cerstva && (cerstva.dataset.paidSignature || "") === podpis) return cerstva;
    } catch (e) {
      console.warn("[zz-loyalty] sekci se nepodařilo doptat", e);
    }
    return null;
  }

  // Zásah do košíku. Počítá se TADY, ne na začátku reconcile — průchod, který
  // do košíku nesáhne, není oscilace a nemá čerpat rozpočet. Časovač se
  // nastavuje jen jednou za okno, takže je to skutečné okno od prvního zásahu:
  // dřív ho každý průchod posouval o 5 s dopředu, takže se čítač u zákaznice,
  // která si hraje s množstvím, nevynuloval nikdy a zarážka spadla i na košíku,
  // kde nic neoscilovalo.
  pocitejZasah() {
    this.iterations += 1;
    if (!this.iterationResetTimer) {
      this.iterationResetTimer = setTimeout(() => {
        this.iterationResetTimer = null;
        this.iterations = 0;
      }, ITERATION_WINDOW_MS);
    }
  }

  zablokujPlacene(variantId) {
    this.paidBlocked.add(variantId);
    this.ulozPaidBlocked();
  }
  odblokujPlacene(variantId) {
    this.paidBlocked.delete(variantId);
    this.ulozPaidBlocked();
  }

  // „dárek byl v košíku" si pamatujeme v sessionStorage, aby detekce ručního
  // smazání přežila i full-reload flow na stránce /cart.
  //
  // Ukládá se PODPIS PLACENÉHO KOŠÍKU a čas, ne jednička.
  //
  // „Dárek tu byl a teď není" znamená „zákaznice ho smazala" JEN TEHDY, když
  // se mezitím nezměnilo, co je v košíku placeného. Když se placený obsah
  // změnil, dárek mohl zmizet stovkou jiných způsobů (jiná karta, vyprázdněný
  // košík, dokončená objednávka) — a usoudit z toho „už ho nenabízej" je omyl,
  // který se projeví tiše a drží do konce návštěvy. Přesně tohle Jakub
  // nahlásil jako „nepřidává se samo, ale přes košík to jde": ruční tlačítko
  // totiž ten příznak samo maže.
  //
  // Skutečné smazání dárku podpis nemění (dárkové řádky se do něj nepočítají),
  // takže se pozná dál. Čas je druhá pojistka pro případ, že by se tentýž
  // podpis vrátil po delší době.
  hadGift(variantId, podpis) {
    try {
      const zaznam = sessionStorage.getItem(`zz_had_gift_${variantId}`);
      if (!zaznam) return false;
      const [ulozenyPodpis, kdyText] = zaznam.split("|");
      // Starý formát bez podpisu neumíme přiřadit ke košíku — ignorujeme ho.
      if (kdyText === undefined) return false;
      if (ulozenyPodpis !== podpis) return false;
      const kdy = parseInt(kdyText, 10);
      if (!Number.isFinite(kdy)) return false;
      return Date.now() - kdy < HAD_GIFT_TTL_MS;
    } catch (e) { return false; }
  }
  setHadGift(variantId, value, podpis) {
    try {
      if (value) {
        sessionStorage.setItem(
          `zz_had_gift_${variantId}`,
          `${podpis === undefined ? this.cartSignature || "" : podpis}|${Date.now()}`
        );
      } else {
        sessionStorage.removeItem(`zz_had_gift_${variantId}`);
      }
    } catch (e) { /* private mode */ }
  }
  isDeclined(variantId) {
    try { return sessionStorage.getItem(`zz_declined_${variantId}`) === "1"; } catch (e) { return false; }
  }
  setDeclined(variantId, value) {
    try {
      if (value) sessionStorage.setItem(`zz_declined_${variantId}`, "1");
      else sessionStorage.removeItem(`zz_declined_${variantId}`);
    } catch (e) { /* private mode */ }
  }

  // Zvolená příchuť müsli. Uložená volba platí, jen když je pořád dostupná
  // a zákaznice si tu příchuť mezitím nekoupila (pak by se dárek nepřidal —
  // přidávací větev přeskakuje varianty, které už v košíku jakkoli jsou).
  musliChoice(config) {
    const a = (config.dataset.musliVariantA || "").trim();
    const b = (config.dataset.musliVariantB || "").trim();
    const aOk = config.dataset.musliAAvailable === "true" && a !== "";
    const bOk = config.dataset.musliBAvailable === "true" && b !== "";
    const paid = (config.dataset.musliPaidVariant || "").trim();

    let stored = null;
    try { stored = sessionStorage.getItem(MUSLI_CHOICE_KEY); } catch (e) { /* private mode */ }

    const usable = (v) => v !== "" && v !== paid && ((v === a && aOk) || (v === b && bOk));
    if (stored && usable(stored)) return stored;
    if (usable(a)) return a;
    if (usable(b)) return b;
    // Obě příchutě koupené nebo vyprodané — nárok nikam nevede.
    return "";
  }

  setMusliChoice(variantId) {
    try { sessionStorage.setItem(MUSLI_CHOICE_KEY, variantId); } catch (e) { /* private mode */ }
    // Volba je akce zákaznice, ne oscilace — zarážka i čítač se pouští znovu.
    // (Checkbox na produktovce kolagenu tohle historicky nedělal a po tvrdém
    // zastavení přestal fungovat; nekopírovat ten vzor.)
    this.stopped = false;
    this.iterations = 0;
    const a = document.querySelector(CONFIG_SELECTOR)?.dataset.musliVariantA?.trim();
    const b = document.querySelector(CONFIG_SELECTOR)?.dataset.musliVariantB?.trim();
    [a, b].forEach((v) => { if (v) { this.setDeclined(v, false); delete this.autoRemoved[v]; } });
    this.reconcile();
  }

  gifts(config, cart) {
    // Kolik shakerů a odměrek se má přibalit počítá SERVER po jednotlivých
    // řádcích, protože dva kolageny můžou mít každý jinou volbu. Tady se to
    // jen přečte — dopočítávat to z kolagenQty by tu různost zahodilo.
    const shakerQty = parseInt(config.dataset.shakerQty || "0", 10) || 0;
    const odmerkaQty = parseInt(config.dataset.odmerkaQty || "0", 10) || 0;
    const musliQualifies = config.dataset.musliQualifies === "true";
    const chosen = this.musliChoice(config);
    const threshold = config.dataset.musliThresholdLabel || "";
    const musliRemoveMessage = threshold
      ? `Müsli zdarma platí od ${threshold} — odebrali jsme ho z košíku.`
      : "Müsli zdarma jsme odebrali z košíku.";

    const seznam = [
      {
        // shaker — x kolagenů = x shakerů (sleva „získejte 2" se čerpá po
        // dvojicích na každý kolagen; počty dárků musí přesně sedět)
        variantId: (config.dataset.giftVariant || "").trim(),
        available: config.dataset.giftAvailable === "true",
        qualifies: shakerQty > 0,
        desiredQty: shakerQty,
        group: "trio",
        removeMessage: "Dárek patří ke kolagenu — odebrali jsme ho z košíku.",
      },
      {
        // odměrka — x kolagenů = x odměrek
        variantId: (config.dataset.odmerkaVariant || "").trim(),
        available: config.dataset.odmerkaAvailable === "true",
        qualifies: odmerkaQty > 0,
        desiredQty: odmerkaQty,
        group: "trio",
        removeMessage: "Dárek patří ke kolagenu — odebrali jsme ho z košíku.",
      },
      {
        variantId: (config.dataset.musliVariantA || "").trim(),
        available: config.dataset.musliAAvailable === "true",
        qualifies: musliQualifies && chosen !== "" && chosen === (config.dataset.musliVariantA || "").trim(),
        desiredQty: 1,
        group: "musli",
        removeMessage: musliRemoveMessage,
      },
      {
        variantId: (config.dataset.musliVariantB || "").trim(),
        available: config.dataset.musliBAvailable === "true",
        qualifies: musliQualifies && chosen !== "" && chosen === (config.dataset.musliVariantB || "").trim(),
        desiredQty: 1,
        group: "musli",
        removeMessage: musliRemoveMessage,
      },
    ].filter((gift) => gift.variantId !== "");

    const akce = this.akceGift(config);
    if (!akce) return seznam;
    // Úklid po dárku, který přestal stát 0 Kč: variantu, kterou spravuje jiný
    // dárek (handle omylem na müsli), nechá jeho správě a nesahá na ni.
    if (akce.jenDarkove) {
      return seznam.some((gift) => gift.variantId === akce.variantId) ? seznam : [...seznam, akce];
    }
    // Jedna varianta = jeden správce. Kdyby dárek akce byl tatáž varianta
    // jako jiný dárek (testuje se s handle shakeru za 0 Kč, nebo překlep
    // v nastavení), přetahovaly by se o ni dvě položky: jedna by ji
    // přidávala, druhá odebírala. Přednost má akce, druhá položka se vynechá.
    return [...seznam.filter((gift) => gift.variantId !== akce.variantId), akce];
  }

  // AKCE 11.11 – dárek za 0 Kč (produkt podle handle v Nastavení motivu →
  // ZENZENA Akce 11.11). Nárok = akce běží (stav počítá window.ZZAkce podle
  // serverového času, v náhledu nepublikovaného motivu ho jde vynutit)
  // a mezisoučet je nad prahem (počítá server, data-akce-nad-prahem, stejný
  // výpočet jako u ostatních stupňů).
  //
  // KTERÝ ŘÁDEK JE DÁREK: patří k produktu (varianta nebo handle) a ZÁROVEŇ
  // má _zz_gift, nebo stojí 0 Kč (ručně přidaný dárek). Placený řádek téhož
  // handle dárkem není nikdy: správce ho nesrovná na 1 ani nesmaže.
  //
  // CENA: rozhoduje nejvyšší cena ze VŠECH variant produktu (data-akce-cena-max,
  // snippets/zenzena-akce-darek.liquid). Když není 0 Kč (překlep v handle,
  // změněná cena), správce dárek nepřidá a vypíše varování. Odebere jen řádky
  // s _zz_gift: ty přidal sám, dokud dárek stál 0 Kč, a za automaticky
  // přidaný dárek se platit nesmí (stejné pravidlo jako pojistka giftPaid).
  // Řádky bez _zz_gift si zákaznice koupila sama, ty zůstanou.
  akceGift(config) {
    const variantId = (config.dataset.akceVariant || "").trim();
    if (!variantId) return null;
    const handle = (config.dataset.akceHandle || "").trim();
    const label = config.dataset.akceLabel || "Dárek";
    const cenaText = (config.dataset.akceCenaMax || "").trim();
    if (cenaText === "" || parseInt(cenaText, 10) !== 0) {
      if (!this.akceVarovano) {
        this.akceVarovano = true;
        console.warn(`[zz-loyalty] dárek akce 11.11 (${handle || variantId}) nestojí 0 Kč (nejvyšší cena varianty ${cenaText || "?"}), do košíku ho nepřidám`);
      }
      return {
        variantId,
        handle,
        poHandle: true,
        jenDarkove: true,
        available: false,
        qualifies: false,
        desiredQty: 0,
        group: "akce",
        removeMessage: `${label} už není zdarma — odebrali jsme ho z košíku.`,
      };
    }
    const stav = window.ZZAkce ? window.ZZAkce.stav : null;
    const prah = config.dataset.akcePrahLabel || "";
    let removeMessage = `Akce skončila — ${label} jsme odebrali z košíku.`;
    if (stav === "bezi") removeMessage = `${label} platí od ${prah} — odebrali jsme ho z košíku.`;
    else if (stav === "pred") removeMessage = `Akce ještě nezačala — ${label} jsme odebrali z košíku.`;
    return {
      variantId,
      handle,
      poHandle: true,
      jenDarkove: false,
      available: config.dataset.akceAvailable === "true",
      qualifies: stav === "bezi" && config.dataset.akceNadPrahem === "true",
      desiredQty: 1,
      group: "akce",
      addMessage: `${label} je v košíku 🎁`,
      removeMessage,
    };
  }

  async reconcile() {
    let cart = null;
    if (window.Shopify && window.Shopify.designMode) return; // v editoru do košíku nesaháme
    const config = document.querySelector(CONFIG_SELECTOR);
    if (!config) return;

    if (this.busy) {
      this.pending = true;
      return;
    }
    // ZARÁŽKA proti oscilaci: po sérii zásahů v krátkém okně se do košíku
    // chvíli nesahá. Dřív to byla západka na celé načtení stránky a to byl
    // špatný obchod — kdo ji jednou spustil, tomu dárky do konce návštěvy
    // tiše nefungovaly a nic mu to neřeklo. Oscilace navíc pramenila z toho,
    // že dárky visely na slevě a hnaly se za ní; od chvíle, kdy jsou to
    // produkty za 0 Kč, není za čím oscilovat. Zarážka teď jen počká.
    if (this.stopped) return;
    if (this.iterations >= ITERATION_BUDGET) {
      this.stopped = true;
      console.warn("[zz-loyalty] reconcile pozastaven — košík se nedaří srovnat, zkusím to za " + STOP_COOLDOWN_MS / 1000 + " s");
      clearTimeout(this.stopResetTimer);
      this.stopResetTimer = setTimeout(() => {
        this.stopped = false;
        this.iterations = 0;
        this.reconcile();
      }, STOP_COOLDOWN_MS);
      return;
    }
    this.busy = true;
    try {
      // Košík se čte VŽDY čerstvý, i když nám nějaký přišel v události.
      // Klíče řádků se po každé mutaci přegenerují a klíč z události už
      // může být neplatný — cart/change.js na něj odpoví
      // „neexistuje platné id nebo parametr řádku" (422), oprava se neprovede,
      // invariant zůstane nesplněný a další průchod to zkusí znovu, dokud
      // nedojde rozpočet iterací. Dárek pak chybí a v košíku svítí červená
      // hláška. Jedno volání navíc je za odstranění téhle smyčky levné.
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
      // AKCE 11.11: serverový čas z čerstvé odpovědi, ať o nároku na dárek
      // nerozhodují hodiny v telefonu (ani stará stránka z cache). Když se tím
      // stav akce změní, ZZAkce zavolá reconcile znovu přes onChange.
      try { window.ZZAkce?.synchronizuj(cartResponse.headers.get("Date")); } catch (e) { /* bez akce nic */ }
      cart = await cartResponse.json();

      // Změnilo se placené zboží? Pak má smysl zkusit dárky znovu.
      const signature = cart.items
        .filter((item) => !(item.properties && item.properties[GIFT_PROPERTY]))
        .map((item) => `${item.variant_id}x${item.quantity}`)
        .join(",");
      const konfig = await this.cerstvaKonfigurace(signature);
      if (!konfig) {
        // Sekce k tomuhle košíku ještě neexistuje. Nic neděláme — až dorazí
        // překreslení, zavolá reconcile znovu. Pojistka pro případ, že by
        // překreslení nedorazilo vůbec.
        clearTimeout(this.staleRetryTimer);
        this.staleRetryTimer = setTimeout(() => this.reconcile(), 600);
        return;
      }

      // AKCE 11.11: začátek, konec a vypínač z čerstvé konfigurace. Konstanty
      // ve skriptu v <head> jsou z doby načtení stránky; když Jakub mezitím
      // akci vypne nebo posune, srovná se to tady (a přes onChange se
      // reconcile zavolá znovu s novým stavem).
      try {
        const d = konfig.dataset;
        if (d.akceStart && window.ZZAkce && typeof window.ZZAkce.nastav === "function") {
          window.ZZAkce.nastav(parseInt(d.akceStart, 10) * 1000, parseInt(d.akceKonec, 10) * 1000, d.akceZapnuto !== "false");
        }
      } catch (e) { /* bez akce nic */ }

      if (signature !== this.cartSignature) {
        this.cartSignature = signature;
        this.paidBlocked = this.nactiPaidBlocked(signature);
      }

      const gifts = this.gifts(konfig, cart);
      const lines = gifts.map((gift) => {
        // Dárek akce (poHandle) se pozná podle varianty NEBO handle, ale jen
        // řádek s _zz_gift nebo za 0 Kč (viz akceGift). Placené řádky téhož
        // handle správce nevidí, takže na ně nesáhne. Ostatní dárky jen podle
        // varianty a s _zz_gift.
        const maDarek = (item) => Boolean(item.properties && item.properties[GIFT_PROPERTY]);
        const patri = gift.poHandle
          ? (item) =>
              (String(item.variant_id) === gift.variantId || (gift.handle !== "" && item.handle === gift.handle)) &&
              (maDarek(item) || (!gift.jenDarkove && item.original_price === 0))
          : (item) => String(item.variant_id) === gift.variantId;
        // POZOR: téže varianty může být v košíku víc dárkových řádků (různé
        // properties). Musíme je vidět všechny, jinak placený dárek proklouzne.
        const giftLines = cart.items.filter((item) => patri(item) && (gift.poHandle || maDarek(item)));
        return {
          gift,
          giftLines,
          lineGift: giftLines[0],
          lineAny: cart.items.find(patri),
          giftQty: giftLines.reduce((sum, item) => sum + item.quantity, 0),
          giftPaid: giftLines.reduce((sum, item) => sum + item.final_line_price, 0),
          // stejný produkt koupený zvlášť: sleva se pak alokuje nepředvídatelně
          // mezi placený a dárkový řádek — počet dárků neupravujeme
          hasPaidLine: !gift.poHandle && cart.items.some(
            (item) =>
              String(item.variant_id) === gift.variantId &&
              !(item.properties && item.properties[GIFT_PROPERTY])
          ),
        };
      });

      // 0) sloučit duplicitní dárkové řádky téže varianty (nechat jen první)
      for (const { gift, giftLines } of lines) {
        if (giftLines.length > 1) {
          // Dárek akce: zůstává řádek s _zz_gift, ručně přidaný jde pryč první.
          const pryc = gift.poHandle
            ? giftLines.find((item) => !(item.properties && item.properties[GIFT_PROPERTY])) || giftLines[giftLines.length - 1]
            : giftLines[giftLines.length - 1];
          await this.changeLine(pryc.key, 0);
          return;
        }
      }

      // 0a) Dárek akce přidaný ručně (bez _zz_gift) se při nároku nahradí
      // řádným: odebrat a v dalším průchodu přidat 1 ks s _zz_gift. Nejde
      // o odmítnutí ani o překlápění, proto bez zapamatujOdebrani a hadGift.
      for (const { gift, lineGift } of lines) {
        if (gift.poHandle && gift.qualifies && lineGift && !(lineGift.properties && lineGift.properties[GIFT_PROPERTY])) {
          this.setHadGift(gift.variantId, false);
          await this.changeLine(lineGift.key, 0);
          return;
        }
      }

      // detekce ručního smazání dárku -> respektovat, dokud na něj trvá nárok
      for (const { gift, lineGift } of lines) {
        if (!gift.qualifies) {
          // Nárok padl (zákaznice vyndala kolagen z košíku). Tím padá i její
          // dřívější „ne, děkuji" — k příštímu kolagenu se dárek nabídne znovu.
          //
          // Bez tohohle stačilo jednou dárek odebrat a do konce návštěvy se
          // nepřidal ani k nově vloženému kolagenu. Navenek to vypadalo, že
          // automatika nefunguje (ruční tlačítko v košíku přitom fungovalo,
          // protože si příznak samo maže) — a nic to nikde neřeklo.
          this.setDeclined(gift.variantId, false);
        }
        if (!lineGift && gift.qualifies && this.hadGift(gift.variantId, signature)) {
          this.setDeclined(gift.variantId, true);
        }
        this.setHadGift(gift.variantId, Boolean(lineGift), signature);
      }

      // 0b) Přepnutí příchuti: starou variantu odebrat DŘÍV, než se přidá nová.
      // Kdyby byly v košíku obě, BXGY pokryje jen jednu a druhá se naúčtuje.
      const staleMusli = lines.find(
        ({ gift, lineGift }) => gift.group === "musli" && !gift.qualifies && lineGift
      );
      if (staleMusli) {
        this.setHadGift(staleMusli.gift.variantId, false); // přepnutí != odmítnutí
        this.zapamatujOdebrani(staleMusli.gift.variantId);
        await this.changeLine(staleMusli.lineGift.key, 0);
        return;
      }

      // 1) BATCH po skupinách. Trio musí jít jednou dávkou (sleva vyžaduje oba
      // kusy), ale müsli s ním jít NESMÍ: cart/add.js je atomický, takže by
      // vyprodané müsli shodilo i shaker s odměrkou (422, nepřidá se nic).
      const batches = new Map();
      for (const { gift, lineAny } of lines) {
        if (gift.qualifies && gift.available && !this.isDeclined(gift.variantId) && !this.paidBlocked.has(gift.variantId) && !this.nedavnoOdebrano(gift.variantId) && !lineAny) {
          if (!batches.has(gift.group)) batches.set(gift.group, []);
          batches.get(gift.group).push({
            id: parseInt(gift.variantId, 10),
            quantity: gift.desiredQty,
            properties: { [GIFT_PROPERTY]: "1" },
          });
        }
      }
      for (const [group, items] of batches) {
        if (items.length > 0) {
          const zprava = lines.find(({ gift }) => gift.group === group && gift.addMessage)?.gift.addMessage || "";
          await this.addGifts(items, group, zprava);
          return; // po mutaci přijde nový cart:change, reconcile poběží znovu
        }
      }

      // 2) odebrání / korekce (VÝHRADNĚ řádky s _zz_gift)
      for (const { gift, lineGift, hasPaidLine, giftPaid } of lines) {
        if (!lineGift) {
          delete this.paidSince[gift.variantId];
          continue;
        }
        if (gift.qualifies === false || this.isDeclined(gift.variantId)) {
          const wasDeclined = this.isDeclined(gift.variantId);
          this.setHadGift(gift.variantId, false); // naše odebrání != odmítnutí
          delete this.paidSince[gift.variantId];
          if (!wasDeclined) this.zapamatujOdebrani(gift.variantId);
          await this.changeLine(lineGift.key, 0);
          if (!wasDeclined) {
            this.notify(gift.removeMessage || "Dárek jsme odebrali z košíku.");
          }
          return;
        }
        // POJISTKA: za auto-přidaný dárek se NIKDY nesmí platit. Krátká tolerance
        // kryje propagaci slevy (aplikuje se, až jsou v košíku oba dárky).
        if (giftPaid > 0) {
          const seen = this.paidSince[gift.variantId];
          if (!seen) {
            this.paidSince[gift.variantId] = Date.now();
            if (!this.paidRecheck) {
              this.paidRecheck = setTimeout(() => {
                this.paidRecheck = null;
                this.reconcile();
              }, 4500);
            }
          } else if (Date.now() - seen > 4000) {
            // PŘEDNOST: dárky ke kolagenu před müsli.
            // Shopify uplatní na objednávku jen JEDNU BXGY slevu, takže když
            // je v košíku müsli i dárky ke kolagenu, jedno druhému slevu sebere
            // a placený zůstane ten, na který nezbylo. Bez tohohle pravidla
            // pojistka odebrala shaker s odměrkou (228 Kč) a nechala müsli
            // (195 Kč) — tedy to horší z obou. Když se za trio platí a müsli
            // v košíku je, ustoupí müsli.
            if (gift.group === "trio") {
              const musliLine = lines.find(
                (l) => l.gift.group === "musli" && l.lineGift
              );
              if (musliLine) {
                this.setHadGift(musliLine.gift.variantId, false);
                this.zablokujPlacene(musliLine.gift.variantId);
                delete this.paidSince[gift.variantId];
                await this.changeLine(musliLine.lineGift.key, 0);
                return;
              }
            }
            this.setHadGift(gift.variantId, false);
            this.zablokujPlacene(gift.variantId);
            delete this.paidSince[gift.variantId];
            // qty > 1: sleva pokryla jen část — místo odebrání celého řádku
            // srazit na počet, který je skutečně zdarma
            const freeQty = Math.max(
              1,
              lineGift.quantity - Math.ceil(lineGift.final_line_price / (lineGift.price || 1))
            );
            if (lineGift.quantity > 1 && freeQty < lineGift.quantity) {
              this.odblokujPlacene(gift.variantId);
              this.setHadGift(gift.variantId, true);
              await this.changeLine(lineGift.key, freeQty);
            } else {
              await this.changeLine(lineGift.key, 0);
            }
            return;
          }
          continue;
        }
        delete this.paidSince[gift.variantId];
        // se samostatně koupeným kusem téhož produktu počty neupravujeme
        if (hasPaidLine) continue;
        // množství dárku drží krok s nárokem (u odměrky = počet kolagenů)
        if (lineGift.quantity !== gift.desiredQty) {
          await this.changeLine(lineGift.key, gift.desiredQty);
          return;
        }
      }
    } catch (error) {
      console.warn("[zz-loyalty] reconcile failed", error);
    } finally {
      this.busy = false;
      if (this.pending) {
        this.pending = false;
        this.reconcile();
      }
    }
  }

  collectSections() {
    const sections = new Set();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } })
    );
    return [...sections].join(",");
  }

  async dispatchCartChange(response) {
    if (window.themeVariables?.settings?.pageType === "cart") {
      window.location.reload();
      return;
    }
    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cart.sections = response.sections;
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "line-item:change", cart },
      })
    );
  }

  async addGifts(items, group = "trio", addMessage = "") {
    this.pocitejZasah();
    // Dárek akce jde mimo sledování Shopify (bez falešného AddToCart), viz
    // fetchMimoSledovani(). Trio a müsli zatím beze změny.
    const cesta = `${Shopify.routes.root}cart/add.js`;
    const init = {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items, sections: this.collectSections() }),
    };
    const response = group === "akce"
      ? await fetchMimoSledovani().posli(new URL(cesta, location.href).href, init)
      : await fetch(cesta, init);
    const json = await response.json();
    if (!response.ok) {
      // typicky vyprodáno (422) — neopakovat do dalšího server-renderu.
      // Bez cart:change nepřijde překreslení, takže zámek musíme sejmout sami,
      // jinak box müsli zůstane zašedlý a neklikatelný do konce návštěvy.
      console.warn("[zz-loyalty] gift add failed", json);
      this.unlockBoxes();
      return;
    }
    items.forEach((item) => this.setHadGift(String(item.id), true));
    // Každá změna košíku přepočítá slevy, takže pozorování „za dárek se platí"
    // z doby před ní už neplatí. Bez tohohle resetu doběhne stará čtyřvteřinová
    // lhůta odměrky ve chvíli, kdy se konflikt slev právě vyřešil, a pojistka
    // ji odebere, přestože už by byla zdarma.
    this.paidSince = {};
    const message = addMessage || (group === "musli" ? "Müsli zdarma je v košíku 🎁" : "Přidali jsme vám dárky zdarma 🎁");
    document.dispatchEvent(new CustomEvent("toast:show", { detail: { message } }));
    await this.dispatchCartChange(json);
  }

  async changeLine(lineKey, quantity) {
    this.pocitejZasah();
    this.paidSince = {}; // viz addGifts — po zásahu do košíku se slevy přepočítají
    const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity, sections: this.collectSections() }),
    });
    const json = await response.json();
    if (!response.ok) {
      console.warn("[zz-loyalty] gift change failed", json);
      this.unlockBoxes();
      return;
    }
    await this.dispatchCartChange(json);
  }

  // Sejme vizuální zámek z boxů, které čekají na překreslení, které nepřijde.
  unlockBoxes() {
    document.querySelectorAll("[data-zz-musli][aria-busy]").forEach((el) => el.removeAttribute("aria-busy"));
  }

  notify(message) {
    const notice = document.querySelector("[data-zz-notice]");
    if (notice) {
      notice.textContent = message;
      setTimeout(() => (notice.textContent = ""), 6000);
    }
    document.dispatchEvent(new CustomEvent("toast:show", { detail: { message } }));
  }

  // Přidání doporučeného produktu (upsell tip v košíku) — běžný řádek bez _zz_gift
  async addProduct(variantId, button = null) {
    if (this.busy) return;
    this.busy = true;
    button?.setAttribute("aria-busy", "true");
    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: this.collectSections(),
        }),
      });
      const json = await response.json();
      if (!response.ok) {
        document.dispatchEvent(new CustomEvent("toast:show", { detail: { message: json.description || json.message || "Produkt se nepodařilo přidat.", tone: "error" } }));
        return;
      }
      await this.dispatchCartChange(json);
    } catch (error) {
      console.warn("[zz-loyalty] upsell add failed", error);
    } finally {
      this.busy = false;
      button?.removeAttribute("aria-busy");
    }
  }

  // znovu povolit jeden dárek (tlačítko v košíku)
  restoreGift(variantId) {
    this.setDeclined(variantId, false);
    this.odblokujPlacene(variantId);
    delete this.autoRemoved[variantId];
    this.stopped = false;
    this.iterations = 0;
    this.reconcile();
  }

  // znovu povolit celé trio (checkbox na produktovce / tlačítko v košíku)
  restoreAllGifts() {
    const config = document.querySelector(CONFIG_SELECTOR);
    if (!config) return;
    [config.dataset.giftVariant, config.dataset.odmerkaVariant].forEach((v) => {
      if (v) { this.setDeclined(v.trim(), false); this.odblokujPlacene(v.trim()); delete this.autoRemoved[v.trim()]; }
    });
    this.stopped = false;
    this.iterations = 0;
    this.reconcile();
  }
}

const giftManager = new ZZGiftManager();
window.ZZLoyalty = giftManager;

// AKCE 11.11: v okamžiku startu nebo konce (časovač v <head>, náhled, oprava
// hodin podle serveru) se košík přepočítá — dárek akce se přidá nebo odebere.
// Viditelné texty se přepnou samy třídou na <html>, sekce se kvůli tomu
// nepřekreslují.
if (window.ZZAkce && typeof window.ZZAkce.onChange === "function") {
  window.ZZAkce.onChange(() => giftManager.reconcile());
}

class ZenzenaUpsellBar extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.sectionId = this.getAttribute("section-id");

    document.addEventListener(
      "cart:prepare-bundled-sections",
      (event) => event.detail.sections.add(this.sectionId),
      { signal }
    );
    document.addEventListener("cart:change", (event) => this.rerender(event.detail.cart), { signal });

    this.addEventListener(
      "click",
      (event) => {
        if (event.target.closest("[data-zz-dismiss]")) {
          try { sessionStorage.setItem("zz_bar_dismissed", "1"); } catch (e) { /* private mode */ }
          this.setAttribute("hidden", "");
        }
      },
      { signal }
    );

    giftManager.reconcile();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  async rerender(cart) {
    try {
      let html = cart?.sections?.[this.sectionId];
      if (!html) {
        html = await (await fetch(`${Shopify.routes.root}?section_id=${this.sectionId}`)).text();
      }
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector("zenzena-upsell-bar");
      if (fresh) {
        this.replaceChildren(...fresh.childNodes);
      }
      // s neprázdným košíkem je lišta vidět vždy; zavření (×) platí jen pro teaser
      const config = this.querySelector(CONFIG_SELECTOR);
      const itemCount = parseInt(config?.dataset.itemCount || "0", 10);
      let dismissed = false;
      try { dismissed = sessionStorage.getItem("zz_bar_dismissed") === "1"; } catch (e) { /* private mode */ }
      if (itemCount > 0 || !dismissed) {
        this.removeAttribute("hidden");
      } else {
        this.setAttribute("hidden", "");
      }
    } catch (error) {
      console.warn("[zz-loyalty] bar rerender failed", error);
    }
    giftManager.reconcile();
  }
}

if (!window.customElements.get("zenzena-upsell-bar")) {
  window.customElements.define("zenzena-upsell-bar", ZenzenaUpsellBar);
}

// Tlačítka „Přidat dárek/dárky" a upsell tip v košíku (delegace — přežije re-render draweru)
document.addEventListener("click", (event) => {
  const trioButton = event.target.closest("[data-zz-add-trio]");
  if (trioButton) {
    event.preventDefault();
    giftManager.restoreAllGifts();
    return;
  }
  const giftButton = event.target.closest("[data-zz-add-gift]");
  if (giftButton) {
    event.preventDefault();
    giftManager.restoreGift(giftButton.getAttribute("data-zz-add-gift"));
    return;
  }
  // Přepnutí příchuti müsli. Pilulka se přebarví hned (ne až po síti) a box
  // se zamkne, dokud drawer nepřijde překreslený — jinak se dá naklikat
  // rychleji, než stihne košík odpovědět.
  const pickButton = event.target.closest("[data-zz-musli-pick]");
  if (pickButton) {
    event.preventDefault();
    // Klik na už zvolenou příchuť nic nemění, takže by nepřišlo překreslení
    // sekce — a zámek by na boxu zůstal natrvalo (zašedlý, neklikatelný).
    if (pickButton.getAttribute("aria-pressed") === "true") return;
    const variantId = pickButton.getAttribute("data-zz-musli-pick");
    const box = pickButton.closest("[data-zz-musli]");
    if (box) {
      box.querySelectorAll("[data-zz-musli-pick]").forEach((b) => {
        const on = b === pickButton;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      box.setAttribute("aria-busy", "true");
    }
    giftManager.setMusliChoice(variantId);
    return;
  }

  // „Přidat müsli" po ručním smazání nebo odmítnutí
  const musliAddButton = event.target.closest("[data-zz-musli-add]");
  if (musliAddButton) {
    event.preventDefault();
    musliAddButton.closest("[data-zz-musli]")?.setAttribute("aria-busy", "true");
    giftManager.setMusliChoice(musliAddButton.getAttribute("data-zz-musli-add"));
    return;
  }

  const upsellButton = event.target.closest("[data-zz-upsell-add]");
  if (upsellButton) {
    // preventDefault: tlačítko sedí uvnitř <summary> — klik nesmí kartičku rozklikávat
    event.preventDefault();
    event.stopPropagation();
    giftManager.addProduct(upsellButton.getAttribute("data-zz-upsell-add"), upsellButton);
  }
});
